import { render, staticRenderFns } from "./Debate.vue?vue&type=template&id=3b21f589&scoped=true&"
import script from "./Debate.vue?vue&type=script&lang=js&"
export * from "./Debate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b21f589",
  null
  
)

export default component.exports